export default __webpack_public_path__ + "static/media/icon_document.819bbbc3.svg";